// extracted by mini-css-extract-plugin
module.exports = {"regionSelector":"RegionSelector_regionSelector__1l_uO","region":"RegionSelector_region__6V6Qm","label":"RegionSelector_label__3SewH"};